<template>
  <div class="contact">
    <div class="header">
      <div class="header-l">
        <el-input
          style="width: 350px"
          placeholder="请输入关键词"
          v-model="q"
          class="input-with-select"
          prefix-icon="el-icon-search"
          @change="onSearch"
        >
          <el-button type="primary" class="btn-p" slot="append" @click="onSearch"
            >查询</el-button
          >
        </el-input>
      </div>
      <div class="header-r">
        <el-button type="primary" icon="el-icon-plus" @click="openAddContact" v-if="this.$route.query.if_leader != 4">
          添加
        </el-button>
        <el-button
          type="danger"
          v-if="delBtn"
          :disabled="lockDel"
          @click="onDelContact"
        >
          <i class="iconfont iconshanchu"></i>
          删除
        </el-button>
      </div>
    </div>
    <div>
      <el-table
        ref="multipleTable"
        :data="contactTable"
        tooltip-effect="dark"
        style="width: 100%"
        :highlight-current-row="true"
        :stripe="true"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" min-width="55"></el-table-column>
        <el-table-column
          prop="owner_name"
          label="负责人"
          min-width="120"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="name"
          label="姓名"
          min-width="120"
        ></el-table-column>
        <el-table-column
          prop="mobile_pc"
          label="手机号"
          min-width="120"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="telephone"
          label="固定电话"
          min-width="120"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column prop="sex" label="性别" min-width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.sex === 1">男</span>
            <span v-if="scope.row.sex === 2">女</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="post"
          label="职务"
          min-width="120"
        ></el-table-column>
        <el-table-column
          prop="remark"
          label="备注"
          min-width="120"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="操作" fixed="right" min-width="240">
          <template slot-scope="scope">
            <el-button
              v-if="contactEditBtn"
              size="mini"
              type="text"
              @click="handleEdit(scope.row)"
              >编辑</el-button
            >
            <el-button size="mini" type="text" @click="handleRead(scope.row)"
              >详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <pagination
        :total="totalContact"
        :page.sync="listQueryContact.page"
        :limit.sync="listQueryContact.limit"
        :page-sizes="[10,20,50,100]"
        @pagination="getContactsList"
      />
    </div>
    <!-- 添加相关联系人 -->
    <add-contact
      v-if="data"
      ref="ContactAdd"
      :type="types"
      :id="data.id"
      :userid="data.owner"
      @handleSubmit="addSubmit"
    ></add-contact>
  </div>
</template>
<script>
import Pagination from "@/components/Pagination";
import addContact from "@/components/Contact/add";
import { contactsList, delContacts } from "@/api/common";
export default {
  name: "contact",
  components: {
    Pagination,
    addContact,
  },
  inject: ["delBtn"],
  props: {
    contactEditBtn: {
      type: Boolean,
      default: true,
    },
    data: {
      type: Object,
      required: true,
    },
    types: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      contactTable: [],
      totalContact: 0,
      listQueryContact: {
        page: 1,
        limit: 20,
      },
      multipleSelection: [],
      q: "",
    };
  },
  mounted() {
    this.getContactsList();
  },
  methods: {
    // 获取联系人列表
    async getContactsList() {
      const params = {
        account_id: this.$store.state.user.token.account_id,
        userid: this.data.owner,
        page: this.listQueryContact.page,
        number_page: this.listQueryContact.limit,
        name: this.q,
      };
      switch (this.types) {
        case "leads":
          Object.assign(params, {
            leads_id: this.data.id,
          });
          break;
        case "customer":
          Object.assign(params, {
            customer_id: this.data.id,
          });
          break;
        default:
          break;
      }
      const res = await contactsList(params);
      if (res.code == 1) {
        this.totalContact = res.count;
        this.contactTable = res.data;
      }
    },
    onSearch() {
      this.totalContact = 0;
      this.contactTable = [];
      this.getContactsList();
    },
    openAddContact() {
      this.$refs.ContactAdd.open();
    },
    addSubmit() {
      // 添加联系人后刷新数据
      this.contactTable = [];
      this.getContactsList();
    },
    async onDelContact() {
      if (!this.multipleSelection.length) {
        this.$message({
          message: "请选择删除项!",
        });
        return;
      }
      this.$confirm("此您确定要删除当前选中联系人吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let ids = [];
          for (const i of this.multipleSelection) {
            ids.push(i.id);
          }
          this.lockDel = true;
          let res = await delContacts({
            account_id: this.$store.state.user.token.account_id,
            userid: this.data.owner,
            ids: ids.join(","),
          });
          if (res.code === 1) {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.contactTable = [];
            this.getContactsList();
          }
          this.lockDel = false;
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 选择相关联系人
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleEdit(data) {
      let name = this._getRouterName();
      // 编辑相关联系人
      Object.assign(data, {
        status: "edit",
      });
      this.$store.commit("app/SET_CONTACT", data);
      this.$router.push({
        name,
        query: {
          id: data.id,
        },
      });
    },
    handleRead(data) {
      let name = this._getRouterName();
      // 查看相关联系人
      Object.assign(data, {
        status: "readonly",
      });
      this.$store.commit("app/SET_CONTACT", data);
      this.$router.push({
        name,
        query: {
          id: data.id,
        },
      });
    },
    _getRouterName() {
      let name;
      switch (this.types) {
        case "leads":
          name = "cluesContactDetail";
          break;
        case "customer":
          name = "customerContactDetail";
          break;
        default:
          break;
      }
      return name;
    },
  },
};
</script>
<style lang="scss" scoped>
.header {
  margin: 0 0 20px !important;
  display: flex;
  justify-content: space-between;
  
}
.contact{
  margin:0 20px; 
}
.btn-p{
  
  border-radius:8px !important;
  background-color:#49B372 !important;
  color:#ffffff !important;
}
.header{
  padding:0px !important;
  background:none ;
}

</style>